import { Component, OnDestroy, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { take, switchMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { UpdUser } from 'app/model/updUser';
import { UpdPassword } from 'app/model/updPassword';
import { PessoaJuridica } from 'app/model/pessoaJuridica';
import { TokenAcesso } from 'app/model/tokenAcesso';
import { User } from 'app/model/user';
import { UsuariosService } from 'app/api/usuarios.service';
import { ClienteApiService } from 'app/api/clienteApi.service';
import { AlertModalService } from 'app/shared/alert-modal.service';
import { LanguageDataTable } from 'app/shared/datatable/translate-datatable';
import { DataTableDirective } from 'angular-datatables';
import { SubSink } from 'subsink';


@Component({
  selector: 'app-usuarios-editar',
  templateUrl: './usuarios-editar.component.html',
  styleUrls: ['./usuarios-editar.component.css']
})
export class UsuariosEditarComponent implements OnInit, OnDestroy {

  usuario: UpdUser;
  usuarioLogado: User;
  usuarioClaims: User;
  cliente: PessoaJuridica;
  clientes: PessoaJuridica[];
  tokens: TokenAcesso[];
  novaSenha: UpdPassword;
  idUsuario: string;
  idCliente: number;

  adicionados = [];
  removidos = [];
  permitions = [];
  roles = [];
  userRole: string = '';

  displayTokenModal = '';
  descricaoTokenModal = '';
  linkCopiado: boolean = false;
  carregando = false;

  alterarSenhaForm: FormGroup;
  gerarTokenForm: FormGroup;
  addForm: FormGroup;

  private subs = new SubSink();

  @ViewChild(DataTableDirective, {static: false})
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  orderCondition: number = 0;
  // order = 'descricao';
  // reverse = true;
  // public paginaAtual = 1;
  // public itensPorPagina = 100;

  constructor(
    private usuariosService: UsuariosService,
    private clientesService: ClienteApiService,
    private route: ActivatedRoute,
    private location: Location,
    private formBuilder: FormBuilder,
    private alertService: AlertModalService) {

      this.gerarTokenForm = this.formBuilder.group({
        descricao: ['', Validators.required],
        expiraEm: ['', Validators.required],
        plataformaIntegrada: ['Plooral']
        // escopos: ['']
      });

     }

  ngOnInit() {

    this.idUsuario = this.route.snapshot.paramMap.get('Id');
    this.getUsuarioLogado();
    this.getClientes();
    this.startDataTable();

    this.alterarSenhaForm = this.formBuilder.group({
      senhaAtual: [''],
      novaSenha: [''],
    });

    this.gerarTokenForm.patchValue({ plataformaIntegrada: 'Plooral' });

  }

  startDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 150,
      processing: true,
      responsive: true,
      order: [[this.orderCondition, "asc"]],
      language: LanguageDataTable.portugues_datatables
    };
  }

  getUsuarioLogado() {
    this.subs.sink = this.usuariosService.v1UsuariosLogadoGet()
    .subscribe(
      usuarioLogado => {
        this.usuarioLogado = usuarioLogado;
        this.getUsuario();
      }
    );
  }

  getUsuario() {
    if (this.usuarioLogado.pessoaJuridicaId === null) { 
      this.subs.sink = this.usuariosService.v1UsuariosUserIdGet(this.idUsuario)
      .subscribe(
        usuario => {
          this.usuario = usuario; // Define o usuário que está sendo editado / model UpdUser
          this.usuarioClaims = usuario; // Define as permissões do usuário editado / model User
          this.userRole = this.usuarioClaims.roles[0];
          let checkClienteRole = localStorage.getItem('clienteRole');
          if(checkClienteRole && checkClienteRole !== this.userRole) {
            this.updatePermition();
          }
          setTimeout(() => {
            this.getCliente();
            this.getToken();
            this.getPermitions();
            this.getRoles();
          }, 0);
          localStorage.setItem('clienteRole', this.userRole);
        }
      );
    } else { 
      this.usuario = this.usuarioLogado; 
      this.getCliente();
    }
  }

  getToken() {

    this.tokens = [];
    this.carregando = true;

    if (this.usuario) {
      this.subs.sink = this.usuariosService.v1UsuariosUserIdTokenGet(this.idUsuario)
      .subscribe(
        tokens => {
          this.tokens = tokens;
          this.carregando = false;
        }
      );
    }
  }

  gerarToken(): void {

    // console.log(this.gerarTokenForm.value);

    if (this.usuarioLogado.pessoaJuridicaId === null) {
      this.usuariosService.v1UsuariosUserIdTokenPost(this.idUsuario, this.gerarTokenForm.value)
      .subscribe(success => {
        this.alertService.showAlertSuccess('Token gerado com sucesso!');
        this.resetFormToken();
        this.getToken();
      }, error => {
        console.log('Erro:', error);
        this.alertService.showAlertDanger('Erro ao gerar Token. Tente novamente mais tarde.');
      });
    } else {
      this.usuariosService.v1UsuariosLogadoTokenPost(this.gerarTokenForm.value)
      .subscribe(success => {
        this.alertService.showAlertSuccess('Token gerado com sucesso!');
        this.resetFormToken();
        this.getToken();
      }, error => {
        console.error("Erro:", error);
        if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
          this.alertService.showAlertDanger(error.Erros[0].Mensagem);
        } else {
          this.alertService.showAlertDanger('Erro ao gerar Token. Tente novamente mais tarde.');
        }
      });
    }
  }

  onCancelToken(idToken) {

    const result$ = this.alertService.showConfirm('Confirmação', 'Tem certeza que deseja revogar este Token?');
    result$.asObservable()
      .pipe(
        take(1),
        switchMap(result => {
          if (result) { 
            if (this.usuarioLogado.pessoaJuridicaId === null) {
              return this.usuariosService.v1UsuariosUserIdTokenIdDelete(this.idUsuario, idToken);
            } else {
              return this.usuariosService.v1UsuariosLogadoTokenIdDelete(idToken);
            }
          } else {
            return EMPTY;
          }
        })
      )
      .subscribe(
        success => {
          this.alertService.showAlertSuccess('Token revogado com sucesso!');
          this.getToken();
        },
        error => {
          console.error("Erro:", error);
          if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
            this.alertService.showAlertDanger(error.Erros[0].Mensagem);
          } else {
            this.alertService.showAlertDanger('Erro ao revogar o Token. Tente novamente mais tarde.');
          }
        }
      );
  }

  configTokenModal(token, name){

    this.displayTokenModal = token;
    this.descricaoTokenModal = name;

    document.getElementById('btnViewTokenModal').click();
    (document.getElementById('inputTokenModal') as HTMLInputElement).value = this.displayTokenModal;

  }

  copyInputMessage(inputElement){
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.linkCopiado = true;

    setTimeout(() => {this.linkCopiado = false}, 2000);
  }

  getClientes() {
    this.subs.sink = this.clientesService.v1ClienteGet()
        .subscribe(
        clientes => {
          this.clientes = clientes;
        }
      );
  }

  getCliente() {
    if (this.usuario) {
      this.idCliente = this.usuario.pessoaJuridicaId;
      if (this.idCliente !== null) {
        this.subs.sink = this.clientesService.v1ClienteClienteIdGet(this.idCliente)
          .subscribe(
          cliente => {
            this.cliente = cliente;
          }
        );
      }
    }
  }

  saveUsuario(): void {
    if (this.usuarioLogado.pessoaJuridicaId === null) {
      this.subs.sink = this.usuariosService.v1UsuariosUserIdPut(this.idUsuario, this.usuario)
      .subscribe(success => {
        this.alertService.showAlertSuccess('Dados do usuário salvos com sucesso!');
        // this.location.back();
        this.getUsuario();
      }, error => {
        console.log(error);
        this.alertService.showAlertDanger('Erro ao salvar usuário. Tente novamente mais tarde.');
      });
    } else {
      this.subs.sink = this.usuariosService.v1UsuariosLogadoPut(this.usuario)
      .subscribe(success => {
        this.alertService.showAlertSuccess('Usuário salvo com sucesso!');
        this.location.back();
      }, error => {
        console.error("Erro:", error);
        if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
          this.alertService.showAlertDanger(error.Erros[0].Mensagem);
        } else {
          this.alertService.showAlertDanger('Erro ao salvar usuário. Tente novamente mais tarde.');
        }
      });
    }
  }

  alterarSenha(): void {
    if (this.usuarioLogado.pessoaJuridicaId === null) {
      this.subs.sink = this.usuariosService.v1UsuariosUserIdAlterarSenhaPut(this.idUsuario, this.alterarSenhaForm.value)
      .subscribe(success => {
        this.alertService.showAlertSuccess('Senha alterada com sucesso!');
        this.resetFormSenha();
      }, error => {
        console.error("Erro:", error);
        if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
          this.alertService.showAlertDanger(error.Erros[0].Mensagem);
        } else {
          this.alertService.showAlertDanger('Erro ao alterar senha. Tente novamente mais tarde.');
        }
      });
    } else {
      this.subs.sink = this.usuariosService.v1UsuariosLogadoAlterarSenhaPut(this.alterarSenhaForm.value)
      .subscribe(success => {
        this.alertService.showAlertSuccess('Senha alterada com sucesso!');
        this.resetFormSenha();
      }, error => {
        console.error("Erro:", error);
        if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
          this.alertService.showAlertDanger(error.Erros[0].Mensagem);
        } else {
          this.alertService.showAlertDanger('Erro ao alterar senha. Tente novamente mais tarde.');
        }
      });
    }
  }

  getPermitions() {

    this.permitions = [];

    this.permitions = [
      { "ativo": 0 , "descricao" : "avaliacao_excluir" },
      { "ativo": 0 , "descricao" : "avaliacao_importacao_listar" },
      { "ativo": 0 , "descricao" : "avaliacao_importacao_obter_pelo_id" },
      { "ativo": 0 , "descricao" : "avaliacao_importar" },
      { "ativo": 0 , "descricao" : "avaliacao_listar_pelo_cargo" },
      { "ativo": 0 , "descricao" : "avaliacao_listar_pelo_cliente" },
      { "ativo": 0 , "descricao" : "avaliacao_listar_pelo_servico_id" },
      { "ativo": 0 , "descricao" : "avaliacao_listar" },
      { "ativo": 0 , "descricao" : "avaliacao_obter_pelo_id" },
      { "ativo": 0 , "descricao" : "avaliacao_perfis_configurar" },
      { "ativo": 0 , "descricao" : "avaliacao_perfis_listar" },
      { "ativo": 0 , "descricao" : "avaliacao_planilha_obter_pelo_id" },
      { "ativo": 0 , "descricao" : "avaliacao_reimportar" },
      { "ativo": 0 , "descricao" : "avaliado_anexo_detalhes" },
      { "ativo": 0 , "descricao" : "avaliado_anexo_excluir" },
      { "ativo": 0 , "descricao" : "avaliado_anexo_incluir" },
      { "ativo": 0 , "descricao" : "avaliado_anexos_incluir_lote" },
      { "ativo": 0 , "descricao" : "avaliado_anexos_listar" },
      { "ativo": 0 , "descricao" : "avaliado_resultado_obter_pelo_id" },
      { "ativo": 0 , "descricao" : "avaliados_listar" },
      { "ativo": 0 , "descricao" : "cargo_aderencia_listar" },
      { "ativo": 0 , "descricao" : "cargo_atualizar" },
      { "ativo": 0 , "descricao" : "cargo_avaliacao_associar" },
      { "ativo": 0 , "descricao" : "cargo_avaliacao_desassociar" },
      { "ativo": 0 , "descricao" : "cargo_avaliados_referenciados_excluir" },
      { "ativo": 0 , "descricao" : "cargo_avaliados_referenciados_incluir" },
      { "ativo": 0 , "descricao" : "cargo_duplicar" },
      { "ativo": 0 , "descricao" : "cargo_excluir" },
      { "ativo": 0 , "descricao" : "cargo_incluir" },
      { "ativo": 0 , "descricao" : "cargo_listar_pelo_cliente" },
      { "ativo": 0 , "descricao" : "cargo_listar" },
      { "ativo": 0 , "descricao" : "cargo_modelo_aplicar_codigo_referencia" },
      { "ativo": 0 , "descricao" : "cargo_obter_pelo_id" },
      { "ativo": 0 , "descricao" : "cargo_perfis_atualizar" },
      { "ativo": 0 , "descricao" : "cargo_perfis_listar" },
      { "ativo": 0 , "descricao" : "cargo_planilha_obter" },
      { "ativo": 0 , "descricao" : "cargo_resturar" },
      { "ativo": 0 , "descricao" : "cargo_webhook_configurar" },
      { "ativo": 0 , "descricao" : "cargo_webhook_excluir" },
      { "ativo": 0 , "descricao" : "ciencia_fator_atualizar" },
      { "ativo": 0 , "descricao" : "ciencia_fatores_configurar" },
      { "ativo": 0 , "descricao" : "ciencia_listar" },
      { "ativo": 0 , "descricao" : "ciencia_nivel_atualizar" },
      { "ativo": 0 , "descricao" : "ciencia_nivel_listar" },
      { "ativo": 0 , "descricao" : "ciencia_obter_pelo_id" },
      { "ativo": 0 , "descricao" : "ciencia_perfis_atualizar_pelo_cliente" },
      { "ativo": 0 , "descricao" : "ciencia_perfis_atualizar" },
      { "ativo": 0 , "descricao" : "ciencia_perfis_listar_pelo_cliente" },
      { "ativo": 0 , "descricao" : "ciencia_perfis_listar" },
      { "ativo": 0 , "descricao" : "cliente_atualizar" },
      { "ativo": 0 , "descricao" : "cliente_excluir" },
      { "ativo": 0 , "descricao" : "cliente_incluir" },
      { "ativo": 0 , "descricao" : "cliente_listar" },
      { "ativo": 0 , "descricao" : "cliente_obter_pelo_id" },
      { "ativo": 0 , "descricao" : "email_anexo_download" },
      { "ativo": 0 , "descricao" : "email_anexo_excluir" },
      { "ativo": 0 , "descricao" : "email_anexo_incluir" },
      { "ativo": 0 , "descricao" : "email_anexo_listar" },
      { "ativo": 0 , "descricao" : "email_configuracoes_definir" },
      { "ativo": 0 , "descricao" : "email_configuracoes_obter" },
      { "ativo": 0 , "descricao" : "email_enviar_teste" },
      { "ativo": 0 , "descricao" : "email_enviar" },
      { "ativo": 0 , "descricao" : "email_mensagem_detalhes" },
      { "ativo": 0 , "descricao" : "email_mensagem_listar" },
      { "ativo": 0 , "descricao" : "email_rascunho_atualizar" },
      { "ativo": 0 , "descricao" : "email_rascunho_excluir" },
      { "ativo": 0 , "descricao" : "email_rascunho_incluir" },
      { "ativo": 0 , "descricao" : "lgpd_anonimizar" },
      { "ativo": 0 , "descricao" : "lgpd_relatorio_dados_pessoais_logs" },
      { "ativo": 0 , "descricao" : "lgpd_relatorio_dados_pessoais" },
      { "ativo": 0 , "descricao" : "lgpd_relatorio_mapeamentos_obter" },
      { "ativo": 0 , "descricao" : "listagem_atualizar" },
      { "ativo": 0 , "descricao" : "listagem_avaliado_cargo_excluir" },
      { "ativo": 0 , "descricao" : "listagem_avaliado_cargo_incluir" },
      { "ativo": 0 , "descricao" : "listagem_avaliado_cargo_listar" },
      { "ativo": 0 , "descricao" : "listagem_avaliado_excluir" },
      { "ativo": 0 , "descricao" : "listagem_avaliado_incluir" },
      { "ativo": 0 , "descricao" : "listagem_avaliado_listar" },
      { "ativo": 0 , "descricao" : "listagem_excluir" },
      { "ativo": 0 , "descricao" : "listagem_incluir" },
      { "ativo": 0 , "descricao" : "listagem_listar" },
      { "ativo": 0 , "descricao" : "listagem_obter_pelo_id" },
      { "ativo": 0 , "descricao" : "logs_auditoria_pesquisar" },
      { "ativo": 0 , "descricao" : "notificacao_pesquisar" },
      { "ativo": 0 , "descricao" : "notificacao_reenviar" },
      { "ativo": 0 , "descricao" : "servico_atualizar" },
      { "ativo": 0 , "descricao" : "servico_excluir" },
      { "ativo": 0 , "descricao" : "servico_incluir" },
      { "ativo": 0 , "descricao" : "servico_listar_pelo_cliente" },
      { "ativo": 0 , "descricao" : "servico_listar" },
      { "ativo": 0 , "descricao" : "servico_obter_pelo_id" },
      { "ativo": 0 , "descricao" : "tipo_servico_atualizar" },
      { "ativo": 0 , "descricao" : "tipo_servico_excluir" },
      { "ativo": 0 , "descricao" : "tipo_servico_incluir" },
      { "ativo": 0 , "descricao" : "tipo_servico_listar" },
      { "ativo": 0 , "descricao" : "tipo_servico_obter_pelo_id" },
      { "ativo": 0 , "descricao" : "usuario_atualizar_permissoes_todos" },
      { "ativo": 0 , "descricao" : "usuario_atualizar_permissoes" },
      { "ativo": 0 , "descricao" : "usuario_atualizar" },
      { "ativo": 0 , "descricao" : "usuario_bloquear" },
      { "ativo": 0 , "descricao" : "usuario_desbloquear" },
      { "ativo": 0 , "descricao" : "usuario_excluir" },
      { "ativo": 0 , "descricao" : "usuario_incluir" },
      { "ativo": 0 , "descricao" : "usuario_listar" },
      { "ativo": 0 , "descricao" : "usuario_logado_atualizar_permissoes" },
      { "ativo": 0 , "descricao" : "usuario_logado_atualizar" },
      { "ativo": 0 , "descricao" : "usuario_logado_obter" },
      { "ativo": 0 , "descricao" : "usuario_logado_senha_alterar" },
      { "ativo": 0 , "descricao" : "usuario_logado_token_gerar" },
      { "ativo": 0 , "descricao" : "usuario_logado_token_listar" },
      { "ativo": 0 , "descricao" : "usuario_logado_token_obter" },
      { "ativo": 0 , "descricao" : "usuario_logado_token_revogar" },
      { "ativo": 0 , "descricao" : "usuario_obter_pelo_id" },
      { "ativo": 0 , "descricao" : "usuario_senha_alterar" },
      { "ativo": 0 , "descricao" : "usuario_token_gerar" },
      { "ativo": 0 , "descricao" : "usuario_token_listar" },
      { "ativo": 0 , "descricao" : "usuario_token_obter" },
      { "ativo": 0 , "descricao" : "usuario_token_revogar" }
    ];

    if(this.usuarioClaims && this.usuarioClaims.claims) {
      const formattedClaims = new Set(this.usuarioClaims.claims.map(claim => claim.replace(/\./g, "_")));
      this.permitions.forEach(permition => {
          if (formattedClaims.has(permition.descricao)) {
              permition.ativo = 1;
          }
      });
    }

    return this.permitions;

  }

  getRoles() {
    this.roles = [
      {"descricao" : "Administrador"},
      {"descricao" : "Cliente"}
    ]

    return this.roles;
  }

  updateUserRole() {
    this.userRole = this.userRole;
  }

  addPermition(permition: string) {
    this.adicionados.push(permition);
    this.removidos = this.removidos.filter(item => item !== permition);
    this.permitions.forEach(item => {
      if (item.descricao == permition) {
        item.ativo = 1;
      }
    });
  }
  
  removePermition(permition: string) {
    this.removidos.push(permition);
    this.adicionados = this.adicionados.filter(item => item !== permition);
    this.permitions.forEach(item => {
      if (item.descricao == permition) {
        item.ativo = 0;
      }
    });
  }

  updatePermition() {

    this.subs.sink = this.usuariosService.v1UsuariosUserIdAtualizarPermissoesPut(this.usuarioClaims.id)
    .subscribe(success => {
      console.log(success);
      this.alertService.showAlertSuccess('Permissões atualizadas com sucesso!');
      this.getUsuario();
    }, error => {
      console.error("Erro:", error);
      if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
        this.alertService.showAlertDanger(error.Erros[0].Mensagem);
      } else {
        this.alertService.showAlertDanger('Erro ao revogar permissões. Tente novamente mais tarde.');
      }
    });

  }

  resetFormSenha() {
    this.alterarSenhaForm.reset();
  }

  resetFormToken() {
    this.gerarTokenForm.reset();
    this.gerarTokenForm.patchValue({ plataformaIntegrada: 'Plooral' });
  }

  goBack(): void {
    this.location.back();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}

